const normalizeDetails = (items = [], type) => (items || []).map((item) => ({ ...item, type: item.type || type }));

export const getSalaryDetails = (salary = {}) => {
  const directDetails = salary.salary_details || salary.salaryDetails || [];
  if (directDetails.length > 0) return directDetails;

  return [
    ...normalizeDetails(salary.facilities, "facility"),
    ...normalizeDetails(salary.insurances, "insurance"),
    ...normalizeDetails(salary.deductions, "deduction"),
    ...normalizeDetails(salary.work_bonuses || salary.workBonuses, "work_bonus"),
    ...normalizeDetails(salary.others, "other"),
  ];
};

export const getTypedSalaryDetails = (salary = {}, type) => getSalaryDetails(salary).filter((detail) => detail.type === type);

export const isMorningMealDetail = (detail = {}) => /makan pagi|uang makan pagi/i.test(String(detail.name || ""));

export const getMorningMealDetail = (salary = {}) => getTypedSalaryDetails(salary, "facility").find(isMorningMealDetail);

export const getDetailLineTotal = (detail = {}) => {
  if (!detail) return null;
  const total = detail.total ?? detail.total_amount ?? detail.subtotal;
  if (total !== undefined && total !== null) return Number(total || 0);
  return Number(detail.amount || 0) * Number(detail.quantity || 1);
};

export const getApiMorningMealTotal = (salary = {}) => {
  const fields = [
    "morning_meal_total",
    "morningMealTotal",
    "total_morning_meal_cost",
    "totalMorningMealCost",
    "total_morning_meal",
    "totalMorningMeal",
    "morning_meal_cost",
    "morningMealCost",
  ];
  const key = fields.find((field) => Object.prototype.hasOwnProperty.call(salary, field));
  if (!key) return null;
  const value = Number(salary[key] || 0);
  return Number.isFinite(value) ? value : null;
};

export const getMorningMealTotal = (salary = {}) => {
  const apiTotal = getApiMorningMealTotal(salary);
  if (apiTotal !== null) return apiTotal;
  const detailTotal = getDetailLineTotal(getMorningMealDetail(salary));
  if (detailTotal !== null) return detailTotal;
  return 0;
};

export const getMorningMealDays = (salary = {}) => Number(
  salary.morning_meal_days ??
  salary.morningMealDays ??
  getMorningMealDetail(salary)?.quantity ??
  0
);

export const getMorningMealRate = (salary = {}) => Number(
  salary.morning_meal_rate ??
  salary.morningMealRate ??
  getMorningMealDetail(salary)?.amount ??
  0
);

export const getOtherFacilityDetails = (salary = {}) => getTypedSalaryDetails(salary, "facility").filter((detail) => !isMorningMealDetail(detail));

export const hasSalaryDetails = (salary = {}) => getSalaryDetails(salary).length > 0;

export const getOtherFacilityTotal = (salary = {}) => {
  if (hasSalaryDetails(salary)) {
    return getOtherFacilityDetails(salary).reduce((total, detail) => total + Number(getDetailLineTotal(detail) || 0), 0);
  }
  const explicitValue = salary.other_facility_total ?? salary.total_other_facilities ?? salary.facility_total_excluding_meal;
  if (explicitValue !== undefined && explicitValue !== null) return Number(explicitValue || 0);
  return Number(salary.total_facilities || 0);
};

export const getFacilityTotal = (salary = {}) => Number(salary.total_facilities || 0);

export const getDetailRowsByType = (salary = {}, type, fallbackKey) => {
  const details = getTypedSalaryDetails(salary, type);
  if (details.length > 0) return details;
  return salary[fallbackKey] || [];
};
